import { render, staticRenderFns } from "./AdvisoryIconHeader.vue?vue&type=template&id=c312ee6c&scoped=true"
import script from "./AdvisoryIconHeader.vue?vue&type=script&lang=js"
export * from "./AdvisoryIconHeader.vue?vue&type=script&lang=js"
import style0 from "./AdvisoryIconHeader.vue?vue&type=style&index=0&id=c312ee6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c312ee6c",
  null
  
)

export default component.exports